// Keep these in sync with the CSS variables in src/styles/globals.css (@theme --breakpoint-*)

export const cssVariables = {
  breakpoints: {
    '3xl': 1920,
    '2xl': 1536,
    wrapper: 1360,
    xl: 1280,
    lg: 1024,
    'md-lg': 960,
    md: 768,
    sm: 640,
    xs: 480,
    xxs: 360,
  },
}
